import { OfferListingApiClient } from '@fourthwall/services/dist/OfferListingApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useOffersListingQuery = createQueryHook(OfferListingApiClient.getOffersListing, {
  queryKey: ['offersListing'],
  select: (data) => {
    data.offers = data.offers.map((offer) => ({ ...offer, name: decodeHtmlEntities(offer.name) }))

    return data
  },
})
